import { useSignups } from "Signups/state";
import API from "Signups/API.js";

export function useRefreshSignupListsData() {
  const [, dispatch] = useSignups();

  return () => {
    const getSignupLists = API.getSignupLists();
    getSignupLists.post().then((res) => {
      dispatch({
        type: "setSignupListsData",
        payload: res,
      });
    });
  };
}
